// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// const user = JSON.parse(localStorage.getItem('user') || '{}');

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.general.dachboard, icon: ICONS.analytics },
      {
        title: 'Sales',
        path: PATH_DASHBOARD.sales.root,
        icon: ICONS.ecommerce,
      },
      {
        title: 'StockIn',
        path: PATH_DASHBOARD.stockin.root,
        icon: ICONS.folder,
        children: [
          { title: 'Add Stock', path: PATH_DASHBOARD.stockin.new },

          { title: 'View Stock', path: PATH_DASHBOARD.stockin.list },
        ],
      },
      // {
      //   title: 'Create Invoice(stckin)',
      //   path: PATH_DASHBOARD.stockinnew.root,
      //   icon: ICONS.folder,
      //   children: [
      //     { title: 'Create Invoice', path: PATH_DASHBOARD.stockinnew.new },

      //     { title: 'View Invoice', path: PATH_DASHBOARD.stockinnew.list },
      //   ],
      // },

      {
        title: 'StockOut',
        path: PATH_DASHBOARD.stockout.root,
        icon: ICONS.external,
        children: [
          { title: 'StockOut', path: PATH_DASHBOARD.stockout.new },

          { title: 'View StockOut', path: PATH_DASHBOARD.stockout.list },
        ],
      },
      // {
      //   title: 'Create Invoice(stckout)',
      //   path: PATH_DASHBOARD.stockoutnew.root,
      //   icon: ICONS.external,
      //   children: [
      //     { title: 'create Invoice', path: PATH_DASHBOARD.stockoutnew.new },

      //     { title: 'View Invoice', path: PATH_DASHBOARD.stockoutnew.list },
      //   ],
      // },

      {
        title: 'Transactions',
        path: PATH_DASHBOARD.stockout1.root,
        icon: ICONS.invoice,
        children: [
          // { title: 'StockOut', path: PATH_DASHBOARD.stockout.new },

          { title: 'View Transactions', path: PATH_DASHBOARD.stockout1.list },
          { title: 'View Payment', path: PATH_DASHBOARD.newpayment.list },
            { title: 'Generate Invoice', path: PATH_DASHBOARD.generateinvoice.list },
        ],
      },

      {
        title: 'Detailbill',
        path: PATH_DASHBOARD.newdetaillbill.root,
        icon: ICONS.label,
        children: [
          // { title: 'StockOut', path: PATH_DASHBOARD.stockout.new },

          { title: 'View Detailbill', path: PATH_DASHBOARD.newdetaillbill.list },
        ],
      },

      // {
      //   title: 'Payments',
      //   path: PATH_DASHBOARD.newpayment.root,
      //   icon: ICONS.external,
      //   children: [
      //     // { title: 'StockOut', path: PATH_DASHBOARD.stockout.new },

      //     { title: 'View Payment', path: PATH_DASHBOARD.newpayment.list },
      //   ],
      // },

      // {
      //   title: 'Create Invoice',
      //   path: PATH_DASHBOARD.stockout.root,
      //   icon: ICONS.external,
      //   children: [
      //     // { title: 'StockOut', path: PATH_DASHBOARD.stockout.new },

      //     { title: 'View FinalInvoice', path: PATH_DASHBOARD.stockout1.list },
      //   ],
      // },

      {
        title: 'Client',
        path: PATH_DASHBOARD.customer.root,
        icon: ICONS.user,
        children: [
          { title: 'Create Client', path: PATH_DASHBOARD.customer.new },

          { title: 'list', path: PATH_DASHBOARD.customer.list },
        ],
      },

      {
        title: 'Product',
        path: PATH_DASHBOARD.productmeta.root,
        icon: ICONS.cart,
        children: [
          { title: 'Create Product', path: PATH_DASHBOARD.productmeta.new },

          { title: 'list', path: PATH_DASHBOARD.productmeta.list },
        ],
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
];

export default navConfig;
